export default __webpack_public_path__ + "static/media/binance.ec406c68.png";